module.exports = __webpack_public_path__ + "static/media/body_system_header.0c266a69.svg";